<template>
  <v-row v-if="doc">
    <v-col
      v-for="item in doc.selectedList"
      :key="item.id"
      :data-id="item.id"
      cols="12"
    >
      <v-card light>
        <v-card-title>
          {{ item.title }}
        </v-card-title>
        <v-card-subtitle>
          <p>{{ item.description }}</p>
          <v-chip :color="colorClass(item.value)">{{ item.value }}</v-chip>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
// import lodash from "lodash";

export default {
  name: "TilesViewer",
  data() {
    return {
      cols: 4,
      doc: null,
    };
  },
  props: {
    uid: String,
  },
  watch: {
    uid() {
      this.getExercise();
    },
  },
  methods: {
    getExercise() {
      console.log("get exercise", this.uid);
      // get a ref to the exercise and listen to changes
      let ref = fb.functionalityExCollection.where("uid", "==", this.uid);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.doc = items[0];
          }
        })
        .catch(function() {});
    },
    colorClass(val) {
      switch (val) {
        case "5":
          return "green accent-1";
        case "10":
          return "green accent-2";
        case "25":
          return "green accent-3";
        case "50":
          return "green accent-4";
      }
    }
  },
  computed: {
    // sortedList() {
    //   return this.doc ? lodash.orderBy(this.doc.selectedList , "index", "asc") : [];
    // },
    computedWidh() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    },
  },
};
</script>
